export enum ModalTheme {
    Normal = 'normal',
    Warn = 'warn',
}
